import { render } from "./SignupView.vue?vue&type=template&id=1335b222"
import script from "./SignupView.vue?vue&type=script&lang=js"
export * from "./SignupView.vue?vue&type=script&lang=js"

import exportComponent from "D:\\CAS Project\\ESM Web App\\master ESM-WEB\\esm-web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__